import { render, staticRenderFns } from "./StockOnHandItemReport.vue?vue&type=template&id=01844b46"
import script from "./StockOnHandItemReport.vue?vue&type=script&lang=js"
export * from "./StockOnHandItemReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports